import { UserCheck } from 'lucide-react';
import { AdminTable } from './AdminTable';
import AdminPageHeader from './AdminPageHeader';

interface AdminUsageProps {
  userInsights: any[];
}

const AdminUsage = ({ userInsights }: AdminUsageProps) => {
  const columns = [
    {
      header: 'Consumer',
      cell: (u: any) => (
        <div className="flex items-center gap-3">
          <UserCheck className="h-4 w-4 text-muted-foreground shrink-0" />
          <span className="text-sm font-medium text-foreground truncate max-w-[150px]">
            {u.email || u.user_id?.slice(0, 12)}
          </span>
        </div>
      ),
    },
    {
      header: 'Requests',
      className: 'text-center',
      cell: (u: any) => (
        <span className="text-sm font-semibold">{u.total_requests}</span>
      ),
    },
    {
      header: 'Total Cost (USD)',
      cell: (u: any) => (
        <span className="text-sm font-mono text-foreground font-semibold tracking-tight">
          ${u.total_cost_usd?.toFixed(4)}
        </span>
      ),
    },
    {
      header: 'Avg Latency',
      cell: (u: any) => (
        <div className="flex items-center gap-3">
          <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden w-16 sm:w-24">
            <div 
              className="h-full bg-primary rounded-full" 
              style={{ width: `${Math.min(100, (u.avg_latency_ms / 5000) * 100)}%` }} 
            />
          </div>
          <span className="text-xs text-muted-foreground font-mono shrink-0">
            {Math.round(u.avg_latency_ms)}ms
          </span>
        </div>
      ),
    },
    {
      header: 'Status',
      cell: () => (
        <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 uppercase tracking-widest">
          Optimal
        </span>
      ),
    },
  ];

  return (
    <div className="animate-in fade-in duration-500">
      <div className="mb-6">
        <AdminPageHeader 
          title="AI Usage & Resource Consumption"
          description="Monitoring LLM costs and latency per user segment."
        />
      </div>

      <AdminTable
        data={userInsights}
        columns={columns}
        keyExtractor={(item) => item.user_id}
        emptyState="No usage data available."
      />
    </div>
  );
};

export default AdminUsage;
